﻿const validateLastName = () => {
    const digitsExactLength = document.querySelectorAll(
        "[digits-only-min-length]"
    );
    const digitsMaxLengthValue = digitsExactLength[0]?.getAttribute(
        "digits-only-max-length"
    );
    const digitsMinLengthValue = digitsExactLength[0]?.getAttribute(
        "digits-only-min-length"
    );
    const digitsExactMessageValue = digitsExactLength[0]?.getAttribute(
        "digits-only-error-message"
    );

    if (digitsMaxLengthValue && digitsExactMessageValue && digitsMinLengthValue) {
        const lastNameInput = document.querySelector("[digits-only-min-length]");
        const lastNameInputValue = lastNameInput.value;
        const regex = new RegExp(`^[0-9]{${digitsMinLengthValue},${digitsMaxLengthValue}}$`);
        const isLastNameMandatory = document.querySelector('#RequiredMarkerPatientLastName');
        const isLastNameEmpty = lastNameInputValue.trim() === '';
        const isValid = isLastNameMandatory
            ? regex.test(lastNameInputValue)
            : regex.test(lastNameInputValue) || isLastNameEmpty;

        return {
            isValid,
            message: digitsExactMessageValue,
        };
    }

    return {
        message: '',
        isValid: true
    }
}

const validateRegex = () => {
    const lastNameInput = document.querySelector("[digits-only-min-length]");

    // When last name is mandatory/optional and has digits only validation disabled then result should be as before our changes were made
    if (!lastNameInput) {
        return true;
    }

    document.querySelector('.is-invalid-last-name')?.remove();
    document
        .querySelector(".add_to_cart-hcp")
        ?.classList.remove("is-disabled");
    const { isValid, message } = validateLastName();

    if (!isValid) {
        let node = document.createElement("li");
        let textnode = document.createTextNode(message);
        node.appendChild(textnode);
        node.classList.add('is-invalid-last-name');
        document.querySelector('.configurator_summary__errors ul').appendChild(node);
        document.querySelector('.configurator_summary__errors').classList.remove('is-hidden');
        document
            .querySelector(".configurePatientInfo")
            .classList.add("has-error");
        document.querySelector("[digits-only-min-length]").classList.add("is-invalid");
        document
            .querySelector(".add_to_cart-hcp")
            ?.classList.add("is-disabled");

        return false;
    } else {
        return true;
    }
}


export function validation() {
    let debugFunction = false;

    let consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
    let consoleParentTrue = 'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleParentTrueGap = 'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
    let consoleParentFalse = 'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleParentFalseGap = 'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
    let consoleChildTrue = 'background: #77AB59; color: #fff; padding: 2px 10px;border-left:80px solid white;';
    let consoleChildFalse = 'background: #E35B5D; color: #fff; padding: 2px 10px;border-left:80px solid white;';

    if (debugFunction) { console.log('%c Validation ', consoleInfo); }

    let requiredQuestions = document.querySelectorAll('.configurator__label--required, .label--required');
    let checkPageQuestions = [];
    let checkPageQuestionsHeadings = [];
    const addToCartBtn = document.querySelector('.add_to_cart-hcp');
    const summaryErrors = document.querySelector('.configurator_summary__errors');
    let leftSideString = document.querySelector('.configurator__selector__side.configurator__selector__side--left label').innerHTML;
    let rightSideString = document.querySelector('.configurator__selector__side.configurator__selector__side--right label').innerHTML;
    checkRequiredFields();

    // Check if page is valid
    function checkPage(displayError) {
        if (debugFunction) { console.log('%c Questions not valid: ' + checkPageQuestions + ' ', consoleParentFalse); }
        if (debugFunction) { console.log('%c Questions not valid: ' + checkPageQuestionsHeadings + ' ', consoleParentFalse); }
        if (checkPageQuestions.length === 0) {
            if (debugFunction) { console.log('%c Page is valid ', consoleParentTrueGap); }
            summaryErrors.classList.add('is-hidden');
            addToCartBtn?.classList.remove('is-disabled');
            return true;
        } else {
            if (debugFunction) { console.log('%c Page is not valid ', consoleParentFalseGap); }
            if (displayError) {
                summaryErrors.classList.remove('is-hidden');
                // Error position depends on sibling elements height
                let siblingHeight = window.getComputedStyle(document.querySelector('.cta_controller')).getPropertyValue('height');
                summaryErrors.style.bottom = siblingHeight;
                validateRegex();
            }
            addToCartBtn?.classList.add('is-disabled');
            return false;
        }
    }


    // This will/can be replaced on BE by using existing required functionality to add class server side
    requiredQuestions.forEach(question => {
        if (debugFunction) { console.log('%c Add new classes for consistency ', consoleInfo); }
        if (question.closest('.configurator__section__fields__subsection')) {
            question.parentNode.classList.add('is-required');
            question.parentNode.classList.add('is-required-wrapper');
        } else if (question.closest('.form-group')) {
            question.closest('.form-group').classList.add('is-required');
            question.closest('.form-group').classList.add('is-required-wrapper');
        }
    });


    // On click
    // Loop through all h2's with required class
    // Find specific parent and apply class so we can target entire question
    // For each required question loop through inputs and find if its a text, select, checkbox etc
    // Check that input is valid on a question by question basis
    // If invalid assign that item to array for each specific question
    // Add help text to left for each question
    // If question is invalid assign it to an overal array for each errored question
    // As user fixes issues update array on each question
    // If question has no invalids remove it from overall array
    // When overall array is empty then page is valid

    function checkQuestionGeneric(displayError) {
        if (debugFunction) { console.log('%c checkQuestionGeneric ', consoleInfo); }
        checkPageQuestions = [];

        // Loop through all required questions
        let requiredWrappers = document.querySelectorAll(
            ".is-required-wrapper, .requiredAudiogram"
        );
        let requiredWrappersVisible = [...requiredWrappers].filter(element => !element.closest('.configurator__section__fields--disabled'));

        requiredWrappersVisible.forEach((wrapper, i) => {
            let heading = wrapper.querySelector('label') ? wrapper.querySelector('label').innerText.trim().replace('*', '').replace(':', '') : null;
            // Audiogram heading
            if (wrapper.querySelector('.audiogram__graph-frame')) {
                let headings = wrapper.closest('.configurator__section').querySelectorAll('h2, h3');
                let arrayOfHeadings = Array.from(headings);
                // Find first heading without an empty string
                heading = arrayOfHeadings.find(el => el.innerText.length > 1).innerText.trim().replace('*', '').replace(':', '');
            }
            let uniqueId = 'requiredItem' + i;

            // Bundled vs Unbundled
            let bundled = wrapper.querySelectorAll('input[type="checkbox"]');
            if (bundled.length > 0) {
                bundled = true;
            } else {
                bundled = false;
            }

            if (debugFunction) {
                console.log('%c ' + heading + ' Found ', consoleParentTrue);
                if (bundled) {
                    console.log('%c ' + heading + ' Bundled ', consoleParentTrue);
                }
            }

            let checkQuestionsInvalid = [];
            let itemsToValidate = [];
            let questionToValidateConditional = '';
            let errorMessageList = document.querySelector('.configurator_summary__errors ul');


            // For Inputs
            // e.g Patient Name, Chargers
            let inputFields = wrapper.querySelectorAll('input');
            let inputFieldsNoAudiogram = [...inputFields].filter(element => !element.closest('#cssConfigureAudiogram'));

            inputFieldsNoAudiogram.forEach((inputField, i) => {
                let inputFieldType = inputField.getAttribute('type');

                // Some inputs are hidden and should not be validated
                // Some inputs are display none after selecting other options, patient vs stock
                // e.g checkboxes for bundled receivers
                let isHidden = false;
                if (inputField.closest('.is-hidden') || inputField.closest('.configurator__section').style.display === 'none' || inputField.disabled) {
                    isHidden = true;
                } else {
                    isHidden = false;
                }


                // If input type text and has .form-control class
                // e.g Patient Name
                if (inputFieldType === 'text' && inputField.classList.contains('form-control') && isHidden == false) {
                    itemsToValidate.push(inputField);
                    if (inputField.value === '') {
                        if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                        // If displayError is true but also if the inputField has a parent with this class, otherwise do nothing
                        displayError ? inputField.closest('.form-group') ? inputField.closest('.form-group').classList.add('is-invalid') : null : null;
                        checkQuestionsInvalid.push(wrapper);
                    } else {
                        if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                        inputField.closest('.form-group') ? inputField.closest('.form-group').classList.remove('is-invalid') : null;
                        // Check if an invalid question exists and remove it now that it is valid
                        let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                        if (findQuestion > 0) {
                            checkQuestionsInvalid.splice(findQuestion, 1);
                        }
                    }
                    questionToValidateConditional = checkQuestionsInvalid.length > 0;
                }

                if (inputFieldType === 'file' && inputField.classList.contains('configurator__input') && isHidden == false) {
                    itemsToValidate.push(inputField);
                    if (inputField.value === '') {
                        if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                        // If displayError is true but also if the inputField has a parent with this class, otherwise do nothing
                        displayError ? inputField.closest('.form-group') ? inputField.closest('.form-group').classList.add('is-invalid') : null : null;
                        checkQuestionsInvalid.push(wrapper);
                    } else {
                        if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                        inputField.closest('.form-group') ? inputField.closest('.form-group').classList.remove('is-invalid') : null;
                        // Check if an invalid question exists and remove it now that it is valid
                        let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                        if (findQuestion > 0) {
                            checkQuestionsInvalid.splice(findQuestion, 1);
                        }
                    }
                    questionToValidateConditional = checkQuestionsInvalid.length > 0;
                }

            })


            // For Selects
            // e.g Warranty
            // If select menu option is first item and that options value is blank then error
            let selectFields = wrapper.querySelectorAll('select');
            selectFields.forEach((selectField, i) => {

                let isHidden = false;
                if (selectField.closest('.disabled-div') || selectField.closest('.is-required-wrapper').querySelector('.form-select__el.is-disabled') || selectField.classList.contains('is-disabled')) {
                    isHidden = true;
                } else {
                    isHidden = false;
                }

                if (isHidden == false) {
                    if (selectField.closest('product-dropdown')) {
                        // Inside a product dropdown so do nothing
                    } else if (selectField.closest('.configurator__accessories-filters')) {
                        // Inside a filter so do nothing
                    } else {
                        itemsToValidate.push(selectField);
                        if (selectField.options[selectField.selectedIndex].index === 0 && selectField.options[0].value === '') {
                            if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                            displayError ? selectField.closest('.form-select')?.querySelector('.form-select__el')?.classList.add('is-invalid') : null;
                            checkQuestionsInvalid.push(wrapper);
                        } else {
                            if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                            selectField.closest('.form-select')?.querySelector('.form-select__el')?.classList.remove('is-invalid');
                            // Check if an invalid question exists and remove it now that it is valid
                            let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                            if (findQuestion > 0) {
                                checkQuestionsInvalid.splice(findQuestion, 1);
                            }
                        }
                        questionToValidateConditional = checkQuestionsInvalid.length > 0;
                    }
                }

            })

            // Textarea
            // e.g Special instructions
            // Check if empty
            let textareaFields = wrapper.querySelectorAll('textarea');
            if (textareaFields.length > 0) {
                textareaFields.forEach((textareaField, i) => {
                    itemsToValidate.push(textareaField);
                    if (textareaField.value === '') {
                        if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                        displayError ? textareaField.closest('.form-group') ? textareaField.closest('.form-group').classList.add('is-invalid') : null : null;
                        checkQuestionsInvalid.push(wrapper);
                    } else {
                        if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                        textareaField.closest('.form-group') ? textareaField.closest('.form-group').classList.remove('is-invalid') : null;
                        let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                        if (findQuestion > 0) {
                            checkQuestionsInvalid.splice(findQuestion, 1);
                        }
                    }
                    questionToValidateConditional = checkQuestionsInvalid.length > 0;

                })
            }

            // Audiogram
            if (wrapper.querySelector('.audiogram__graph-frame')) {
                let questionValuesRight = [];
                let questionValuesRightSum = 0;
                let questionValuesLeft = [];
                let questionValuesLeftSum = 0;

                let rightAudiogram = wrapper.querySelector('#graphRightEar');
                let rightAudiogramInputs = rightAudiogram ? rightAudiogram.querySelector('.audiogram__input').querySelectorAll('input') : null;
                if (rightAudiogram) {
                    rightAudiogramInputs.forEach(input => {
                        let inputValue = +input.value;
                        questionValuesRight.push(inputValue);
                    });
                } else {
                    questionValuesRight.push(1);
                }

                let leftAudiogram = wrapper.querySelector('#graphLeftEar');
                let leftAudiogramInputs = leftAudiogram ? leftAudiogram.querySelector('.audiogram__input').querySelectorAll('input') : null;
                if (leftAudiogram) {
                    leftAudiogramInputs.forEach(input => {
                        let inputValue = +input.value;
                        questionValuesLeft.push(inputValue);
                    });
                } else {
                    questionValuesLeft.push(1);
                }

                // If sum is 0 then nothing has been updated on graph
                questionValuesRightSum = questionValuesRight.reduce((partialSum, a) => partialSum + a, 0);
                // If sum is 0 then nothing has been updated on graph
                questionValuesLeftSum = questionValuesLeft.reduce((partialSum, a) => partialSum + a, 0);

                // If either side has been updated show the summary
                if (questionValuesRightSum == 0 || questionValuesLeftSum == 0) {
                    questionToValidateConditional = true;
                    checkQuestionsInvalid.push(wrapper);
                } else {
                    questionToValidateConditional = false;
                    // Check if an invalid question exists and remove it now that it is valid
                    let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                    if (findQuestion > 0) {
                        checkQuestionsInvalid.splice(findQuestion, 1);
                    }
                }

            }

            if (checkQuestionsInvalid.length > 0) {
                if (debugFunction) { console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildFalse); }
            } else {
                if (debugFunction) { console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildTrue); }
            }

            if (questionToValidateConditional) {
                if (debugFunction) { console.log('%c ' + heading + ' Not Valid', consoleChildFalse); }
                // If error message already exists do nothing
                if (errorMessageList.querySelector('#' + uniqueId + '')) {
                    // Do nothing
                } else {
                    // Add errored questions
                    // We are using the string from the heading field as it is translatable
                    let node = document.createElement("li");
                    let textnode = document.createTextNode(heading);
                    node.appendChild(textnode);
                    node.setAttribute("id", uniqueId);
                    node.setAttribute("class", checkSide(wrapper));

                    let spanSide = '';
                    spanSide = document.createElement('span');
                    spanSide.classList.add('side');
                    if (checkSide(wrapper) === 'Right') {
                        // Use translated side string
                        spanSide.innerHTML = rightSideString;
                        node.prepend(spanSide);
                    } else if (checkSide(wrapper) === 'Left') {
                        // Use translated side string
                        spanSide.innerHTML = leftSideString;
                        node.prepend(spanSide);
                    }

                    errorMessageList.appendChild(node);

                    let rightSideWidth = '';
                    let leftSideWidth = '';

                    // Equalise the width of the side strings (Left and Right for example)
                    if (document.querySelector('.configurator_summary__errors .Right .side')) {
                        rightSideWidth = document.querySelector('.configurator_summary__errors .Right .side').getBoundingClientRect().width;
                    }
                    if (document.querySelector('.configurator_summary__errors .Left .side')) {
                        leftSideWidth = document.querySelector('.configurator_summary__errors .Left .side').getBoundingClientRect().width;
                    }
                    if (rightSideWidth > leftSideWidth) {
                        document.querySelectorAll('.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side').forEach(item => {
                            item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
                        });
                    } else if (rightSideWidth < leftSideWidth) {
                        document.querySelectorAll('.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side').forEach(item => {
                            item.setAttribute('style', 'width:' + leftSideWidth + 'px; text-align:center;');
                        });
                    } else if (rightSideWidth = leftSideWidth) {
                        document.querySelectorAll('.configurator_summary__errors .Right .side, .configurator_summary__errors .Left .side').forEach(item => {
                            item.setAttribute('style', 'width:' + rightSideWidth + 'px; text-align:center;');
                        });
                    }

                }
                // Add error class from parent question
                displayError ? wrapper.classList.add('has-error') : null;
                // If this string exists in the array dont push it again
                // -1 means it has not been found
                let findQuestion = checkPageQuestions.indexOf(uniqueId);
                if (findQuestion < 0) {
                    checkPageQuestions.push(uniqueId);
                }
                let findHeading = checkPageQuestionsHeadings.indexOf(heading);
                if (findHeading < 0) {
                    checkPageQuestionsHeadings.push(heading);
                }
            } else {
                if (debugFunction) { console.log('%c ' + heading + ' Valid ', consoleChildTrue); }
                // If error message exists remove it
                if (errorMessageList.querySelector('#' + uniqueId + '')) {
                    errorMessageList.querySelector('#' + uniqueId + '').remove();
                }
                // Remove error class from parent question
                wrapper.classList.remove('has-error');
                // If this string exists in the array remove it
                // -1 means it has not been found
                let findQuestion = checkPageQuestions.indexOf(uniqueId);
                if (findQuestion >= 0) {
                    checkPageQuestions.splice(findQuestion, 1);
                }
                let findHeading = checkPageQuestionsHeadings.indexOf(heading);
                if (findHeading >= 0) {
                    checkPageQuestionsHeadings.splice(findHeading, 1);
                }
            }
        })

        // Check page is valid
        return checkPage(displayError);
    }


    function checkSide(question) {
        let checkSide = question.closest('.configurator__section__fields') ? question.closest('.configurator__section__fields').classList.contains('configurator__section__fields--right') : null;
        let inputSide = '';
        if (question.closest('.configurator__section').querySelector('.configurator__section__fields--disabled')) {
            inputSide = 'Binaural'
        } else {
            if (question.closest('.configurator__section__fields')) {
                // Right side
                if (checkSide) {
                    inputSide = 'Right'
                } else {
                    inputSide = 'Left'
                }
            } else if (question.closest('.configurator__section__monoBorder')) {
                inputSide = null;
            }
        }
        return inputSide;
    }


    // Submit button
    addToCartBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        if (debugFunction) { console.log('%c Click Submit ', consoleInfo); }
        checkPageQuestions = [];
        //clear errors list only if it's hidden (initial load)
        if (document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')) {
            document.querySelector('.configurator_summary__errors ul').innerHTML = '';
        }

        const isValid = checkQuestionGeneric(true);
        const isLastnameValid = validateRegex();

        if (isValid && isLastnameValid) {
            checkoutActions(e.target);
        }
    });

    /**
     * Checkout actions
     * 1. Show checkout modal
     * 2. Save and return to cart (when edit product from cart)
     */
    const checkoutActions = (elem) => {
        const saveAndReturnButtonId = elem.getAttribute('data-button-id');
        const isSaveAndReturn = elem.getAttribute('data-save-and-return');
        const isPostback = typeof (__doPostBack) === 'function';
        // Save and return to cart
        if (saveAndReturnButtonId && isSaveAndReturn == "1" && isPostback) {
            __doPostBack(saveAndReturnButtonId, '', true, '', '', false, false);
            return;
        }
        // Show checkout modal
        document.querySelector('.configurator_modal').showModal();
    }

    function checkRequiredFields() {
        if (requiredQuestions.length === 0) {
            addToCartBtn?.classList.remove('is-disabled');
        }
    }


    // Check on page load (when dom is completed). Fix when return to configuration from edit product in cart
    document.onreadystatechange = () => {
        if (document.readyState === "complete") {
            checkQuestionGeneric(false);
        }
    };
    // Observer required as we need to wait for the disabled fields to be added
    let observerDynamicAreas = new MutationObserver(function (mutations) {
        if (document.querySelector('.configurator__section__fields--disabled') && document.querySelector('.audiogram__graph') && document.querySelector('.configurator__label--required')) {
            observerDynamicAreas.disconnect();
            // no need to run it separately for audiogram
            observerAudiogramAreas.disconnect();
            checkQuestionGeneric(false);
            // detect change in required fields
            let requiredFields = [...document.querySelectorAll('.is-required-wrapper input, .is-required-wrapper select')];
            for (let field of requiredFields) {
                field.addEventListener('change', function () {
                    if (debugFunction) { console.log('%c Change detected ', consoleInfo); }
                    // Reset the list of options or there are issues with id's and labels in the list
                    document.querySelector('.configurator_summary__errors ul').innerHTML = "";
                    checkQuestionGeneric(false);
                })
            };
            // Audiogram specific checks
            let audiogramInputs = [...document.querySelectorAll('#audiogram input.form-control')];
            for (let input of audiogramInputs) {
                input.addEventListener('change', function () {
                    // Reset the list of options or there are issues with id's and labels in the list
                    document.querySelector('.configurator_summary__errors ul').innerHTML = "";
                    checkQuestionGeneric(false);
                })
            };
            let audiogramGraphs = [...document.querySelectorAll('#audiogram .audiogram__graph, #audiogram .btn-secondary')];
            for (let graph of audiogramGraphs) {
                graph.addEventListener('click', function () {
                    // Reset the list of options or there are issues with id's and labels in the list
                    document.querySelector('.configurator_summary__errors ul').innerHTML = "";
                    checkQuestionGeneric(false);
                })
            };
        }
    });
    observerDynamicAreas.observe(document.querySelector('.configurator_controllers'), { attributes: true, childList: true, characterData: false, subtree: true });

    let observerAudiogramAreas = new MutationObserver(function (mutations) {
        if (document.querySelector('.audiogram__graph')) {
            observerAudiogramAreas.disconnect();
            // Audiogram specific checks
            let audiogramInputs = [...document.querySelectorAll('#audiogram input.form-control')];
            for (let input of audiogramInputs) {
                input.addEventListener('change', function () {
                    // Reset the list of options or there are issues with id's and labels in the list
                    document.querySelector('.configurator_summary__errors ul').innerHTML = "";
                    checkQuestionGeneric(false);
                })
            };
            let audiogramGraphs = [...document.querySelectorAll('#audiogram .audiogram__graph, #audiogram .btn-secondary')];
            for (let graph of audiogramGraphs) {
                graph.addEventListener('click', function () {
                    // Reset the list of options or there are issues with id's and labels in the list
                    document.querySelector('.configurator_summary__errors ul').innerHTML = "";
                    checkQuestionGeneric(false);
                })
            };
        }
    });

    let audioGramQuestionSelector = document.querySelector('#cssConfigureAudiogram');
    audioGramQuestionSelector ? observerAudiogramAreas.observe(audioGramQuestionSelector, { attributes: true, childList: true, characterData: false, subtree: true }) : null;

    // detect change in side visible to see if there are more or less required questions now
    let sections = [...document.querySelectorAll('.configurator_controllers .configurator__section')];
    for (let section of sections) {
        section.addEventListener('change', function () {
            if (debugFunction) { console.log('%c Change on Section detected ', consoleInfo); }
            // Reset the list of options or there are issues with id's and labels in the list
            document.querySelector('.configurator_summary__errors ul').innerHTML = "";

            // If errors already showing then run validation again to pick up newly showing field
            // Else dont run validation
            if (!document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')) {
                checkQuestionGeneric(true);
            } else {
                checkQuestionGeneric(false);
            }

        })
    };

    // detect change in any question
    let questions = [...document.querySelectorAll('.is-required-wrapper input, .is-required-wrapper select')];
    for (let question of questions) {
        question.addEventListener('change', function () {
            if (debugFunction) { console.log('%c Change in question detected ', consoleInfo); }
            // Reset the list of options or there are issues with id's and labels in the list
            document.querySelector('.configurator_summary__errors ul').innerHTML = "";

            // If errors already showing then run validation again to pick up newly showing field
            // Else dont run validation
            if (!document.querySelector('.configurator_summary__errors').classList.contains('is-hidden')) {
                checkQuestionGeneric(true);
            } else {
                checkQuestionGeneric(false);
            }

        })
    };

    // Close error message
    const closeBtn = document.querySelector('.close_error_message');
    closeBtn?.addEventListener('click', () => {
        summaryErrors.classList.add('is-hidden');
    });

}
